import React from "react";
import AsesoresHero from "./AsesoresHero";
import NuestrosAsesores from "./NuestrosAsesores";
import Testimonios from "../Testimonios/Testimonios";
import Requirements from "../Requirements";
import Hero3 from "../Hero3";
import Costos from "../EstimarCostos";
import Slider from "../Slider";
import { useCustomNavigate } from "../../utils/customNavigation";

const AsesoresPage = () => {
  const customNavigate = useCustomNavigate();
  const scrollToForm = () => customNavigate("/#form");

  return (
    <>
      <AsesoresHero />
      <NuestrosAsesores />
      <Slider scrollToForm={scrollToForm} />
      <Testimonios />
      <Requirements />
      <Hero3 />
      <Costos />
    </>
  );
};

export default AsesoresPage;
